import { render, staticRenderFns } from "./CmgCreateAccountPage.vue?vue&type=template&id=13c9cd74&scoped=true&lang=pug&"
import script from "./cmg-create-account-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-create-account-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCreateAccountPage.vue?vue&type=style&index=0&id=13c9cd74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9cd74",
  null
  
)

export default component.exports